"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const formik_1 = require("formik");
const next_i18next_1 = require("next-i18next");
const react_1 = __importDefault(require("react"));
const components_common_error_message_1 = require("@hotelplan/components.common.error-message");
const libs_validation_1 = require("@hotelplan/libs.validation");
const Checkbox_1 = __importDefault(require("./Checkbox"));
function ValidatedCheckbox(props) {
    const [t] = (0, next_i18next_1.useTranslation)();
    const { name, showErrorMessage } = props, rest = __rest(props, ["name", "showErrorMessage"]);
    const [field, meta] = (0, formik_1.useField)(name);
    let inputState = (0, libs_validation_1.getValidatedFieldState)(meta.error, meta.touched);
    if (props.readOnly) {
        inputState = libs_validation_1.FieldState.Pending;
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Checkbox_1.default, Object.assign({}, rest, { checked: field.value, onChange: (_, e) => {
                field.onChange(e);
            }, name: name })),
        showErrorMessage && inputState === libs_validation_1.FieldState.Error && (react_1.default.createElement(components_common_error_message_1.ErrorMessage, { getMessage: message => t(message), error: meta.error }))));
}
exports.default = ValidatedCheckbox;
//# sourceMappingURL=ValidatedCheckbox.js.map